import React from 'react';
import PageBanner from '../../../layout/PageBanner';
import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

const InvestigacionesDetalle = (props) => {
  const data = props.location.fields;

  console.log(props)
  console.log(data)
  window.scrollTo(0, 450)
  return (
    <div>
      <div>
        <PageBanner title="Investigaciones" img="banner-prop-int.jpeg">
          <Link to="/">Home</Link>
          <Link to="/propiedad-intelectual">Propiedad Intelectual</Link>
        </PageBanner>

        {(props.location.fields) &&
          <section className="about-ds">
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <div className="single-course-content">
                    <h3 className="course-title flacso-verde">{data.Curso}</h3>
                    <div className="course-meta row">
                      <div className="col-sm-5 course-duration" style={{ display: 'flex'}}>
                        <div className="course-icon" style={{marginRight: '5px'}}><i className="fa fa-calendar fa-2" aria-hidden="true"></i></div>
                        <div className="duration-details">
                          <span>{data.Horario}</span>
                          <span>{data.Fecha}</span>
                        </div>
                      </div>
                    </div>
                    <br/>
                    <div className="course-gallery" style={{textAlign: 'center'}}>
                      <img src={data.Imagen[0].url} alt="cursos" style={{ maxWidth: '749px', maxHeight: '450px' }} />
                    </div>
                    <br/>
                    <div className="course-info-tabs">
                      <Tabs selectedTabClassName="active-tab" >
                        <TabList className="nav nav-tabs">
                          <Tab style={{ bottom: 0 }}><h3>Descripción</h3></Tab>
                          <Tab style={{ bottom: 0 }}><h3>Equipo y dirección docente</h3></Tab>
                          <Tab style={{ bottom: 0 }}><h3>Objetivos</h3></Tab>
                        </TabList>
                        <br />
                        <TabPanel>
                          <p dangerouslySetInnerHTML={{ __html: data.Descripcion }}></p>

                          {("Link Presencial" in data) &&
                            <a className="flacso-verde" href={data["Link Presencial"]}>FORMULARIO DE PREINSCRIPCIÓN PRESENCIAL<br /><br /></a>
                          }

                          {("Link Virtual" in data) &&
                            <a className="flacso-verde" href={data["Link Virtual"]}>FORMULARIO DE PREINSCRIPCIÓN VIRTUAL <br /><br /></a>
                          }

                          {data.Brochure &&
                            <a className="flacso-verde" href={data.Brochure[0].url} style={{ display: "table-cell" }} target="_blank">MÁS INFO</a>
                          }
                        </TabPanel>
                        <TabPanel>
                          <p dangerouslySetInnerHTML={{ __html: data.Equipo }}></p>
                        </TabPanel>
                        <TabPanel>
                          <p dangerouslySetInnerHTML={{ __html: data.Objetivos }}></p>
                        </TabPanel>
                      </Tabs>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </section>
        }

        {props.location.fields === undefined &&
          <div className="contenedor-descripcion">
            <h1>404!</h1>
          </div>
        }

      </div>
    </div>
  )
};

export default InvestigacionesDetalle;
